import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ai-skin-emulation"
    path="business/products/ai-skin-emulation"
    element={<AsyncPage />}
  />,
];
